<template>
    <div>
        <!-- Check email pa -->
        <mdb-container>
            <mdb-row class="mt-5 pt-5">
                <mdb-col class="text-center mt-5 pt-5">
                    <img src="https://kiritek-web-documents.s3-us-west-2.amazonaws.com/trust1/logot1.png" width="200px" height="auto" alt="">
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col class="text-center mt-5">
                    <h1 class="email-confirm-title">Confirmación de e-mail</h1>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col class="text-center mt-3" >
                    <h1 :class="'status-email' + statusClass">{{ status }}</h1>
                    <span ></span>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col class="text-center mt-3">
                    <h3 class="email-confirm-title">{{ message }}</h3>
                </mdb-col>
            </mdb-row>
        </mdb-container>
    </div>
</template>
<script>
    import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
    import { mapActions } from "vuex";

    export default {
        name: "CheckEmail",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol
        },
        data(){
            return {
                verified: false,
                status: '',
                message: '',
                statusClass: ''
            }
        },
        methods: {
            ...mapActions(["confirmEmailAccount"]),
            async confirmEmail(){
                let vueInstance = this;
                try {
                   let response = await this.confirmEmailAccount(this.$route.params.token);

                   this.verified = true;
                   this.status = 'OK!';
                   this.message = response.data.message;
                   this.statusClass = ' status-success'
                } catch(e) {
                    this.verified = true;
                    this.status = 'OOPS!';
                    this.message = e.response.data.errorDetails;
                    this.statusClass = ' status-danger'
                }
            }
        },
        async mounted(){
            await this.confirmEmail();
        }
    }
</script>
<style>
    .email-confirm-title {
        color: #828282; 
        text-align: center;
    }
    
    .status-email {
        margin-left: auto; 
        margin-right: auto; 
        color: #fff; 
        text-align: center; 
        max-width: 120px; 
        border-radius: 6px; 
        padding: 5px;
    }

    .status-success {
        background-color: #00C851; 
    }

    .status-danger {
        background-color: #ff4444; 
    }
</style>